import React from "react";
import { Input } from "antd";
import { Label } from "../../globals";

const InputText = ({
  width,
  name,
  number,
  placeholder,
  onChange,
  blockSize,
  onKeyDown,
  value,
  style,
  error,
  hideLabel = false,
  label = false,
  disabled = false,
}) => {
  return (
    <div
      className="form-group order-input-form-group"
      style={{ width: `${blockSize}` }}
    >
      {!hideLabel && (placeholder || label) && (
        <Label className="text-sm-label" error={error}>{label ? label : placeholder}</Label>
      )}
      <Input
        type="text"
        name={name}
        className="form-control"
        id={`${name + number}`}
        placeholder={placeholder || "Įveskite"}
        style={style || { fontSize: `${width}` }}
        onKeyDown={onKeyDown}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default InputText;
